import { DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const OrganizationAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px;
  height: 32px;
  border-radius: ${DefaultValue.BorderRadius};
`
